// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ajuste{
    margin: 3px;
}

.btn-markAnswer{
    position: fixed;
    right: 0;
    left: 0;
    z-index: 10;
    top: 190px;
    width:5%;
}

.ajuste-contenido::after {
    content: "";
    opacity: 0.5;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }

#divAnswer label{
    font-weight: normal !important;
}

.btnConexion{
    border-radius:250px;
}

.audioGeneral{
    display: -webkit-inline-box;
}

#securityTerritory {
    position: fixed; bottom: 90px; left: 89%;
}

.fix-container-panel-evaluation {
    width: 94%;
    margin-left: 45px;
}

.visible-btn {
  visibility: visible !important;
  display: inline-block !important;
}

#btnStepBack {
  display: inline-block !important;
  visibility: visible !important;
}

#btnStepBack[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
  display: inline-block !important;
  opacity: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/visualizer/visualizer.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,WAAW;IACX,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,WAAW;EACb;;AAEF;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe,EAAE,YAAY,EAAE,SAAS;AAC5C;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,qBAAqB;AACvB","sourcesContent":[".ajuste{\r\n    margin: 3px;\r\n}\r\n\r\n.btn-markAnswer{\r\n    position: fixed;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    top: 190px;\r\n    width:5%;\r\n}\r\n\r\n.ajuste-contenido::after {\r\n    content: \"\";\r\n    opacity: 0.5;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    position: absolute;\r\n    z-index: -1;\r\n  }\r\n\r\n#divAnswer label{\r\n    font-weight: normal !important;\r\n}\r\n\r\n.btnConexion{\r\n    border-radius:250px;\r\n}\r\n\r\n.audioGeneral{\r\n    display: -webkit-inline-box;\r\n}\r\n\r\n#securityTerritory {\r\n    position: fixed; bottom: 90px; left: 89%;\r\n}\r\n\r\n.fix-container-panel-evaluation {\r\n    width: 94%;\r\n    margin-left: 45px;\r\n}\r\n\r\n.visible-btn {\r\n  visibility: visible !important;\r\n  display: inline-block !important;\r\n}\r\n\r\n#btnStepBack {\r\n  display: inline-block !important;\r\n  visibility: visible !important;\r\n}\r\n\r\n#btnStepBack[disabled] {\r\n  background-color: #ccc;\r\n  cursor: not-allowed;\r\n  display: inline-block !important;\r\n  opacity: 1 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
